import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-[#FAF7F2]" ref={ref} data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl p-8 md:p-12 text-center border-2 border-[#6B8F5E]/30 shadow-lg" data-id="element-65">
          <div className="w-20 h-20 rounded-full bg-[#6B8F5E]/10 flex items-center justify-center mx-auto mb-6" data-id="element-66">
            <ShieldCheckIcon className="w-10 h-10 text-[#6B8F5E]" data-id="element-67" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2926] mb-6" data-id="element-68">
            GARANTÍA SEGURA DE 7 DÍAS
          </h2>

          <p className="text-lg text-[#2D2926]/80 mb-4 leading-relaxed" data-id="element-69">
            Prueba la guía durante 7 días completos.
          </p>

          <p className="text-lg text-[#2D2926]/80 mb-4 leading-relaxed" data-id="element-70">
            Si sientes que no es para ti, puedes solicitar la devolución del
            100% de tu dinero.
          </p>

          <p className="text-2xl font-bold text-[#6B8F5E]" data-id="element-71">Sin riesgos.</p>
        </motion.div>
      </div>
    </section>;
}